import React, { useState } from 'react';

import { updateInvoiceSettings } from '../../mutations/invoices/settings';

import InvoiceSettings from './components/InvoiceSettings';
import EditInvoiceSettingsModal from './components/EditInvoiceSettingsModal';

const Settings = (props) => {
  const { invoiceSettings, relay } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState(null);
  const handleModalOpen = () => setIsModalOpen(true);
  const handleModalClose = () => setIsModalOpen(false);

  const handleSubmit = (values) => {
    updateInvoiceSettings(relay.environment, values, {
      onCompleted: handleSubmitSuccess,
    });
  };

  const handleSubmitSuccess = (response) => {
    const { errors } = response.updateInvoiceSettings;
    if (errors) {
      setErrors(errors);
    } else {
      setErrors(null);
      handleModalClose();
    }
  };

  return (
    <div>
      <EditInvoiceSettingsModal
        settings={invoiceSettings}
        onModalClose={handleModalClose}
        isModalOpen={isModalOpen}
        onSubmit={handleSubmit}
        errors={errors}
      />
      <InvoiceSettings
        settings={invoiceSettings}
        onModalOpen={handleModalOpen}
      />
    </div>
  );
};

export default Settings;
